/*
╔═╗┌─┐┌─┐┬─┐┌─┐┌─┐┬┌─┬ ┬┌┬┐┌┬┐┬ ┬
║ ╦├┤ │ │├┬┘│ ┬├┤ ├┴┐│ │ │  │ └┬┘
╚═╝└─┘└─┘┴└─└─┘└─┘┴ ┴└─┘ ┴  ┴  ┴ 
DesignedAndDevelopedBy:Georgekutty @21-07-2019 20:17:05
*/


const feasibilityResponseReducer = (state = {}, action) => {
	if(action.type === 'SET_FEASIBILITY_RESPOSNSE') {
		var newState = {};
		Object.assign(newState,state);
		newState[action.key] = action.payload;
		console.log("Feasibility newState >>", newState);
		return newState;
	}else {
		return state
	}
}

export default feasibilityResponseReducer;
